import React from 'react';
import { Link } from 'react-router-dom';

const s = {
  nav: { background:'#0B1F3A', display:'flex', justifyContent:'space-between',
    alignItems:'center', padding:'1.1rem 2.5rem', position:'sticky', top:0, zIndex:100 },
  logo: { fontFamily:"'Bebas Neue', sans-serif", fontSize:'1.3rem',
    letterSpacing:'3px', color:'#F7F8FA', textDecoration:'none' },
  accent: { color:'#2EBD8A' },
  links: { display:'flex', gap:'2rem', listStyle:'none' },
  link: { color:'#8A9BB0', textDecoration:'none', fontSize:'0.83rem' },
  cta: { background:'#1A9068', color:'#F7F8FA', border:'none', padding:'0.5rem 1.3rem',
    borderRadius:'5px', fontSize:'0.83rem', fontWeight:500, cursor:'pointer', textDecoration:'none' }
};

export default function Navbar() {
  return (
    <nav style={s.nav}>
      <Link to="/" style={s.logo}>No<span style={s.accent}>Immigration</span>Lawyers</Link>
      <ul style={s.links}>
        <li><Link to="/perm-lookup" style={s.link}>PERM Lookup</Link></li>
        <li><Link to="/start" style={s.link}>H1B</Link></li>
        <li><Link to="/start" style={s.link}>Green Card</Link></li>
      </ul>
      <Link to="/start" style={s.cta}>Start my case →</Link>
    </nav>
  );
}